import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/ui/select";
import { cn } from "@/shared/lib/utils";

/** 空值哨兵:Radix Select 的 item value **不许是空串**,而"全部"就是空筛子。 */
export const ANY = "__any__";

/**
 * 获客舱筛子里的一个下拉。今日商机与线索库共用一份 ——
 * 两页各写一个的后果是同一个筛子在两页上一个叫「全部产品」一个叫「不限产品」。
 *
 * ★ `value=""` 表示不筛。外面拿到的也永远是 `""`,哨兵不外泄。
 */
export function AcqPicker({
  label,
  value,
  onChange,
  options,
  className,
  emptyHint,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
  className?: string;
  /** 一个选项都没有时下拉里那句话(例如产品树还没建)。 */
  emptyHint?: string;
}) {
  return (
    <Select value={value || ANY} onValueChange={(v) => onChange(v === ANY ? "" : v)}>
      {/* ★ 0917 批次四(契约 §15.3):触发器对齐系统其它页面的筛选条 ——
          `h-9` + 默认 `text-sm`(军师看板「按部门筛选」、客服会话页状态筛都是这一档)。
          原来是 `text-xs`:同一排里它比旁边的员工选择矮半号,像两套控件拼起来的。 */}
      <SelectTrigger
        className={cn("h-9 w-auto min-w-[8.5rem] gap-2", className)}
        aria-label={label}
      >
        <SelectValue placeholder={label} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ANY}>全部{label}</SelectItem>
        {options.length === 0 && emptyHint && (
          // ★ 空下拉不留白:一个只有「全部」的下拉看起来像没加载完,而其实是真的没东西可筛。
          <div className="px-2 py-1.5 text-2xs text-muted-foreground">{emptyHint}</div>
        )}
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
